<template>
  <figure
    class="flex max-w-[93px]"
    :class="{
      'md:max-w-[142px]': theme === 'default',
      'md:max-w-[180px]': theme === 'kids',
    }"
  >
    <img
loading="lazy"
      class="hidden xl:block w-full"
      :src="'/img/logo/' + siteTheme.images.logo.desktop"
      alt="logo"
    />
    <img
loading="lazy"
      class="block xl:hidden w-full"
      :src="'/img/logo/' + siteTheme.images.logo.mobile"
      alt="logo"
    />
  </figure>
</template>
<script setup>
import siteTheme from "@/static/site-themes";
import {theme} from "@/services/getSiteTheme";
</script>
